
import Assert from "tbAssert";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import TrackerBaseReportsConstants from "./Constants";
import ReportConfiguration from "./ReportConfiguration";

import ReportsMainPageController from "./ReportsMainPageController";

const reportConfiguration = new ReportConfiguration({
    reportDisplayName: "Main Page",
    reportStateName: "mainPage"
});

function ReportsMainPageConfiguration($stateProvider) {

    Assert.StrictAssert($stateProvider != null, "Assertion Failure: Missing UI Router State Provider Dependency");

    $stateProvider.state(
        `${TrackerBaseReportsConstants.rootStateName}.${reportConfiguration.stateName}`, 
        {
            url: "/reports",
            template: ReportsMainPageController.template,
            controller: ReportsMainPageController,
            controllerAs: ReportsMainPageController.controllerAs
        }
    );
}

ReportsMainPageConfiguration.$inject = [ "$stateProvider" ];

ReportsMainPageConfiguration.dependencies = [ "ui.router" ];

const reportsMainPageModuleDependencies = DependencyListBuilder([
    ReportsMainPageController.dependencies,
    ReportsMainPageConfiguration.dependencies
]);

export default {
    moduleName: angular
        .module(
            "trackerbase-app.views.trackerbase-reports.reports-main-page",
            reportsMainPageModuleDependencies
        )
        .config(ReportsMainPageConfiguration)
        .name,
    configs: [ reportConfiguration ]
};



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/ReportsMainPage.js
// module id = r59s
// module chunks = 1